import React, { useEffect } from 'react';
import { Box, Alert, Typography } from '@mui/material';
import { useAuth } from './AuthContext';
import { Navigate } from 'react-router-dom';
import AdminPanel from './AdminPanel';

/**
 * Supervisor Page - Admin-only page accessible only via URL
 * Not shown in menu/navigation
 */
const Supervisor = () => {
  const { isSuperAdmin, isAuthenticated, isLoading, user } = useAuth();

  // Debug logging
  useEffect(() => {
    console.log('Supervisor component mounted/updated:', {
      isSuperAdmin,
      isAuthenticated,
      isLoading,
      userEmail: user?.email,
      user
    });
  }, [isSuperAdmin, isAuthenticated, isLoading, user]);

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Typography>Loading authentication...</Typography>
      </Box>
    );
  }

  if (!isAuthenticated) {
    console.log('Supervisor: Not authenticated, redirecting to login');
    return <Navigate to="/" replace />;
  }

  if (!isSuperAdmin) {
    return (
      <Box sx={{ p: 3, maxWidth: 800, mx: 'auto', mt: 4 }}>
        <Alert severity="error">
          <Typography variant="h6">Access Denied</Typography>
          <Typography variant="body2">
            This page is only accessible to the platform superadmin.
          </Typography>
          <Typography variant="body2" sx={{ mt: 1, fontSize: '0.75rem', color: 'text.secondary' }}>
            Current user: {user?.email?.toLowerCase() || 'Unknown'}
          </Typography>
        </Alert>
      </Box>
    );
  }

  console.log('Supervisor: Rendering AdminPanel');

  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: '#f5f5f5', padding: 0 }}>
      <AdminPanel />
    </Box>
  );
};

export default Supervisor;

